/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_SaveInputs */



/**
* | output |
* | --- |
* | "Override → Finished" |
*
* @param {Override_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_save = /** @type {((inputs?: Override_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier → Terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anular → Finalizada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Substituir → Finalizado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi → Concluso")
	return /** @type {LocalizedString} */ ("Override → Finished")
});